import React, {createContext, useReducer} from 'react'

export const SET_SUB_SYSTEM_LIST = 'SET_SUB_SYSTEM_LIST'
export const SELECT_SUB_SYSTEM = 'SELECT_SUB_SYSTEM'
export const SET_SHOW_SUB_SYSTEM_POPUP = 'SET_SHOW_SUB_SYSTEM_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_SUB_SYSTEM_LIST:
      return { ...data, sub_system_list: payload.data }
    case SELECT_SUB_SYSTEM:
      return {
        ...data,
        selected_sub_system: payload.data.selected_sub_system,
        show_sub_system_popup: payload.data.show_sub_system_popup,
      }
    case SET_SHOW_SUB_SYSTEM_POPUP:
      return {
        ...data,
        show_sub_system_popup: payload.data,
        selected_sub_system: payload.data ? data.selected_sub_system : {},
      }
    default:
      return data
  }
}

const initialState = {
  sub_system_list: [],
  selected_sub_system: {},
  show_sub_system_popup: false,
}

const SubSystemStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <SubSystemContext.Provider value={[state, dispatch]}>
      {children}
    </SubSystemContext.Provider>
  )
}

export const SubSystemContext = createContext(initialState)
export default SubSystemStore
